import { getUtilityClasses } from "./styles";
export const menuDividerClasses = getUtilityClasses("MenuDivider", ["root"]);
